function split(string) {
    let splitString = [];
    let indexOfPre = string.indexOf('<pre>');
    while(indexOfPre >= 0) {
        splitString.push(string.substring(0, indexOfPre));
        let indexOfPreClose = string.indexOf('</pre>') + 6;
        splitString.push(string.substring(indexOfPre, indexOfPreClose));
        string = string.substring(indexOfPreClose)
        indexOfPre = string.indexOf('<pre>');
    }
    if(splitString.length === 0) {
        splitString.push(string);
    }
    return splitString;
}

function reformatHTML(htmlContent) {
    let htmlContents = split(htmlContent);
    let returnContent = "";
    htmlContents.forEach(content => {
        if(content.startsWith("<pre>")){
            let newContent = content.replace(/<br\/>/gm, "");
            newContent = newContent.replace(/<pre>/gm, "");
            newContent = newContent.replace(/<\/pre>/gm, "");
            newContent = newContent.replace(/&lt;/gm, "<");
            newContent = newContent.replace(/&gt;/gm, ">");
            newContent = newContent.replace(/amp;/gm, "");
            returnContent += newContent;
        }
        else {
            returnContent += content;
        }
    });
    return returnContent;
}

export default {reformatHTML};